const com90 = {
	length: { min: 3, max: 3 },
	payload: [
		{ length: 1, name: "código", type: "bytes", description: "Código de configuración (1 byte).", pad: "00" },
		{ length: 2, name: "mAh", description: "Capacidad de la batería (mAh). Valores entre 0 y 19000. Tamaño: 2 bytes.", type: "bytes", range: { min: 0, max: 19000 }, pad: "0000" },
	],
};

export default com90;